import { useState, useEffect } from "react";
import React from "react";
import { connect } from 'react-redux';
import * as actions from "store/actions";
import Button from "components/CustomButtons/Button";
import Notification from "components/Notification/NotificationFixedTop";
import NotificationAsk from "components/Notification/NotificationAsk";
import { clone, debounce, get } from "lodash";
import axios from "store/axios/axios-files";
import { formatDate2, getFileExtension, handleError, isImage, makeid } from "../../shared/utility";
import { IconButton } from "@material-ui/core";
import { ClipLoader } from "react-spinners";
import CustomTextArea from "components/CustomTextArea/CustomTextArea.jsx";
import CustomSimpleDialog from "../CustomDialog/CustomSimpleDialog";
import Inputt from "../CustomInput/Inputt";
import TableSmall from "../Table/TableSmall";
import moment from "moment";

function convertFilenameToDashed(name) {
    return name
        .trim()                  // Remove leading/trailing whitespace
        .toLowerCase()           // Optional: make it lowercase
        .replace(/\s+/g, '-')    // Replace spaces (including multiple spaces) with dashes
        .replace(/[^a-z0-9\-\.]/g, ''); // Optional: remove special characters except dash and dot
}


const ALLOWED_FILE_EXT = ['jpg','jpeg','webp','png','gif','heic','mp4','pdf'];
const ACCEPTED_FILE_EXT = ".jpg,.jpeg,.webp,.png,.gif,.heic,.mp4,.pdf,.doc,.docx,.xls,.xlsx";

// REQUIRED PROPS
// --------------
// update - function
// remove - function
// field - string field name
// the_filename <optional>
// type = "crm" or "rs"

const Thumb = ({ src, alt = "" }) => {
  if (!src) return null;

  return (
    <a
      href={src}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: "block", textDecoration: "none" }}
    >
      <div
        style={{
          width: "100%",
          height: 180,          // <-- set your uniform height here
          overflow: "hidden",
          borderRadius: 6,
          background: "#f3f3f3"
        }}
      >
        <img
          src={src}
          alt={alt}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",  // <-- makes them all same size, crops as needed
            display: "block"
          }}
        />
      </div>
    </a>
  );
};


const BucketUploader = (props) => {
    const [file, setFile] = useState(null);
    const [notification, setNotification] = useState('');
    const [ask, setAsk] = useState(false);
    const [photoPreview, setPhotoPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [notes, setNotes] = useState('');
    const [beforeNotes, setBeforeNotes] = useState('');
    const [openedChooseFiles, setOpenedChooseFiles] = useState(false);
    const [files, setFiles] = useState([]);
    const [inputVal, setInputVal] = useState('');
    const [photoPreviews, setPhotoPreviews] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const emptyState = () => {
        setFile(null);
        setNotification('');
        setPhotoPreview(null);
        setPhotoPreviews({});
    }

    console.log('PhotoUploader', props)

    const filterFunction = f => {
        if (f.filename) {
            const ext = getFileExtension(f.filename).toLowerCase();
            if (ALLOWED_FILE_EXT.indexOf(ext) === -1) {
                return false;
            }
            const lower = inputVal.toLowerCase();
            const lower2 = f.filename.toLowerCase();
            if (lower2.indexOf(lower) !== -1) {
                return true;
            }
        }
        return false;
    }

    const handleChange = (event) => {
        setFile(event.target.files[0])
    }

    const loadOwnFiles = async () => {
            setLoading(true);
            setFiles([]);
            try {
                const response = await axios.get('/data?own=true');
                console.log('loaded files', response.data);
                if (response.data.length === 0) {
                    setNotification('No existing files found');
                }
                setFiles(response.data);
                setLoading(false);
                const obj = {};
                const id_obj = {};
                response.data.forEach(rd => {
                    if (rd.filename) {
                        const ext = getFileExtension(rd.filename).toLowerCase();
                        if (ALLOWED_FILE_EXT.indexOf(ext) !== -1) {
                            obj[rd.filename] = null;
                            id_obj[rd.filename] = rd.id;
                        }
                    }
                });
                setPhotoPreviews(obj);
            } catch(e) {
                handleError(e);
                setNotification('error getting files, please try again');
            }
            setLoading(false);
        }

    const refresh = async (the_filename) => {
        if (the_filename) {
            const the_arr = the_filename.split(',')
            if (the_arr.length > 1) {
                const the_file = the_arr[0];
                const the_date = the_arr[1] ? the_arr[1] : '';
                setPhotoPreview(the_file);
            }
        }
    }

    const uploadFile = async (data) => {
        setLoading(true);
        console.log('action', data, )
        try {
            const formData = new FormData();
            const originalname = data.file.name;
            const cleaned_filename = convertFilenameToDashed(originalname);
            const newname = `${makeid(5)}-${cleaned_filename}`;
            formData.append("file", data.file, newname);
            formData.append("sfiletype", data.type);
            formData.append("notes", data.notes ? data.notes : '');
            const response = await axios.post('/bucket-upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const rdata = response.data;
            const file_uploaded = get(rdata, 'url', null);
            const date_file_uploaded = moment().format('MM/DD/YYYY');
            props.update(`${file_uploaded},${date_file_uploaded}`, notes);
            refresh(`${file_uploaded},${date_file_uploaded}`);
        } catch(e) {
            console.log(e);
            setNotification('error uploading, please try again');
        }
        setLoading(false);
        setFile(null);
    }

    const remove = async (bucket_filename) => {
        try {
            props.update(``);
            const filename = bucket_filename.replace('https://storage.googleapis.com/illi-properties/', '');
            await axios.post('/bucket-delete', {
                filename
            });
            setNotification('Deleted media file');
            setTimeout(() => {
                setNotification('');
            }, 4000);
        } catch(e) {
            setNotification('Error deleting media file, please try again.');
        }
    }

    const saveNotes = async () => {
        if (notes) {
            try {
                await axios.post('/update_notes', {
                    id: the_id,
                    notes
                });
                setNotification('Updated notes');
                setTimeout(() => {
                    setNotification('');
                }, 4000);
                setBeforeNotes(notes);
            } catch(e) {
                setNotification('Error updating notes, please try again.');
            }
        }
    }

    const fetchPreview = async (listo, length) => {
        console.log('listo', listo);
        if (!length) length = listo.length;
        const obj = {};
        for (let i = 0; i < length; i++) {
            const fl = listo[i];
            const the_id = fl.id;
            try {
                if (the_id) {
                    const response = await axios.get('/download?id='+the_id+'&type=crm', {responseType: 'blob'});
                    if (response.data) {
                        const src = URL.createObjectURL(response.data);
                        obj[fl.filename] = src;
                    }
                }
            } catch(err) {
                handleError(err);
            }
        }
        setPhotoPreviews(obj);
    }

    useEffect(() => {
        const debouncedFn = debounce(() => {
            console.log('Debounced inputVal:', inputVal);
            // Put your API call or logic here
            if (inputVal) {
                const photos = files.filter(filterFunction);
                //fetchPreview(photos, 10);
            }
        }, 500); // 500ms delay

        debouncedFn();

        // Cleanup: cancel debounce if inputVal changes before 500ms
        return () => {
            debouncedFn.cancel();
        };
    }, [inputVal]);

    useEffect(() => {
        const the_filename = get(props, 'the_filename', null);
        console.log('just loaded', props.the_filename);
        refresh(the_filename);
        // const photos = files.filter(filterFunction);
        //fetchPreview(photos);
    }, [props.the_filename]);

    let the_file = '';
    let the_id = '';
    let the_date = '';
    const the_filename = get(props, 'the_filename', null);
    if (the_filename) {
        const the_arr = the_filename.split(',')
        if (the_arr.length > 1) {
            the_file = the_arr[0];
            the_id = null;
            the_date = the_arr[1] ? the_arr[1] : '';
        }
    }
    
    if (loading) return <div style={{margin:10}}><ClipLoader /></div>;

    console.log('PhotoUploaderz', photoPreviews, photoPreview, the_filename);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const photos = files.filter(filterFunction);
    const currentItems = photos.slice(indexOfFirstItem, indexOfLastItem);
    const alt = props.the_alt ? props.the_alt : '';

    return <div style={{position:'relative',padding:10}}>
        {props.title && <h4 style={{fontSize:15,fontWeight:'bold'}}>{props.title}</h4>}

        {photoPreview && the_filename && (
        isImage(photoPreview)
            ? 
                props.image_size_the_same ? 

                    <Thumb src={photoPreview} alt="photo" />
                :

                    <img src={photoPreview} style={{ maxWidth: '100%' }} />
            : 
                <a href={photoPreview} download={photoPreview} target="_blank" style={{textDecoration:'underline'}}>Download File</a>
        )}

        {(props.disabled) && <div style={{marginTop:10,marginBottom:10,fontWeight:'bold'}}>{notes}</div>}

        {(the_file && props.setAlt && !props.disabled) && <div><CustomTextArea 
            value={alt}
            onChange={(e) => {
                props.setAlt(e.target.value);
            }}
        />
            {(beforeNotes !== notes && the_id) && <Button size="sm" color="rose" onClick={saveNotes}>Save Notes</Button>}
        </div>}

        {(!the_file && props.update && !props.disabled) && <div>
            <div style={{marginBottom:10}}><input 
                type="file"
                onChange={handleChange}
                style={{width:'100%'}}
                accept={props.show_image ? "image/*" : ACCEPTED_FILE_EXT }
            /></div>
            {props.setAlt && <div className="boxed">
                <small>Alt (alternative text):</small>
                <CustomTextArea 
                    value={alt}
                    onChange={(e) => {
                        if (props.setAlt) {
                            props.setAlt(e.target.value);
                        }
                    }}
                />
            </div>}
            {file && <Button size={props.button_size ? 'lg' : 'sm'} color="primary" className="mr-20" onClick={() => {
                uploadFile({
                    type: props.type,
                    file,
                    notes
                })
            }}>UPLOAD</Button>}
            {props.close && <Button color="white" onClick={() => {
                emptyState();
                props.close();
            }}>CANCEL</Button>}
        </div>}

        {(!the_file && props.update && !props.disabled) && <div>
                    <div style={{marginBottom:10}}>
                        <Button color="primary" size="sm" style={{display:'none'}}
                            onClick={() => {
                                // load
                                setOpenedChooseFiles(true)
                                loadOwnFiles();
                            }}
                        >CHOOSE EXISTING FILE</Button>
                    </div>
                </div>}
        {the_file && <div style={{textAlign:'right'}}>
        {(remove && !props.disabled) && <div style={{position:'absolute',top:'15px',right:5}}><i className="fa fa-trash red-text hoverable" style={{float:'right'}} onClick={() => {
            setAsk(true);
        }}></i></div>}

        {!props.hide_filename && <div style={{overflow:'hidden'}}><em>{the_file}</em></div>}
        {(!props.hide_date && the_date) && <div style={{overflow:'hidden'}}><em><small>Uploaded {the_date}</small></em></div>}

        <IconButton style={{display:'none'}} onClick={() => {
            props.getFileUpload({ id:the_id, type: props.type });
        }}><i className="fa fa-arrow-down red-text"></i></IconButton>
        </div>}

        {notification && <Notification 
            open={notification ? true : false}
            close={() => { setNotification(''); }}
            message={notification}
        />}

        {ask && <NotificationAsk 
            open={ask}
            close={() => { setAsk(false) }}
            title="Are you sure?"
            message={`Do you want to remove this photo "${the_file}" ?`}
            success={() => {
                remove(the_file);
                setAsk(false);
            }}
        />}

        {(openedChooseFiles && files.length > 0) && <CustomSimpleDialog 
            show_close_button={true}
            open={true}
            close={() => {
                setOpenedChooseFiles(false);
            }}
            no_ok_button={true}
            content={<div style={{maxWidth:800}}>
                <h3 style={{marginBottom:0,paddingBottom:0}}>Choose File</h3>
                <Inputt 
                    onChange={(e) => {
                        setInputVal(e.target.value);
                        setCurrentPage(1);
                    }}  
                    value={inputVal}
                    label="Search by Filename"
                />
                <div 
                    /* style={{height:500,overflow:'auto'}} */
                    className="hover-table">
                    <TableSmall 
                        tableHead={[<strong>Filename</strong>,
                                <strong>Preview</strong>,
                                <strong>Date Created</strong>,
                                <strong>Action</strong>]}
                        tableData={currentItems.map(f => {
                            return [
                                f.filename ? f.filename.substring(f.filename.indexOf("-") + 1) : '',
                                <div style={{width:200}}>{photoPreviews[f.filename] &&
                                    <img src={photoPreviews[f.filename]} style={{width:'100%',maxWidth:200}} />}
                                    {!photoPreviews[f.filename] && <IconButton style={{marginRight:20}}
                                        onClick={() => {
                                            fetchPreview([{id:f.id,filename:f.filename}]);
                                        }}
                                    >
                                        <i className="fa fa-eye green-text"></i>
                                    </IconButton>}
                                </div>,
                                formatDate2(f.date_created),
                                <div>
                                    <IconButton style={{marginRight:20}}
                                        onClick={() => {
                                            props.getFileUpload({ id:f.id, type: props.type ? props.type : 'crm' });
                                        }}
                                    >
                                        <i className="fa fa-arrow-down red-text"></i>
                                    </IconButton>
                                    <Button size="sm" color="primary"
                                        onClick={() => {
                                            const file_uploaded = `${f.id},${f.filename}`;
                                            const date_file_uploaded = moment().format('MM/DD/YYYY');
                                            const combo = `${file_uploaded},${date_file_uploaded}`;
                                            props.update(combo);
                                            refresh(combo);
                                            setOpenedChooseFiles(false);
                                        }}
                                    >CHOOSE</Button>
                                </div>
                            ]
                        })}
                    />
                    <div>
                    {Array.from({ length: Math.ceil(photos.length / itemsPerPage) }, (_, i) => (
                        <IconButton
                            key={i + 1}
                            onClick={() => setCurrentPage(i + 1)}
                            style={{ fontWeight: currentPage === i + 1 ? 'bold' : 'normal' }}
                        >
                        {i + 1}
                        </IconButton>
                    ))}
                    </div>
                </div>
            </div>}
        />}

    </div>
}

const mapStateToProps = state => {
    return {
        loading: state.files.loading,
        error_upload: state.files.error_upload,
        success_upload: state.files.success_upload,
        file_uploaded: state.files.file_uploaded,
        date_file_uploaded: state.files.date_file_uploaded,
        photo_preview: state.files.photo_preview
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        createFileUpload: (data) => {
            dispatch(actions.createFileUpload(data));
        },
        getFileUpload: (data) => {
            dispatch(actions.getFileUpload(data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BucketUploader);